import React from "react";
import { Dropdown } from "react-bootstrap";

export default function RestlessDropdownFormatter(
  cellContent,
  row,
  rowIndex,
  { quickActionVerication, btnText, dropdownHeader, actionList }
) {
  return (
    <>
      <Dropdown title="Action" id="dropdown-menu-align-right">
        <Dropdown.Toggle variant="primary" id="dropdown-basic">
          {btnText}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Header>{dropdownHeader}</Dropdown.Header>
          {actionList.map((item) => {
            return (
              <Dropdown.Item
                id={item.action}
                onClick={(e) => quickActionVerication(e, row)}
                eventKey={item.key}
              >
                {item.action}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
